/** Optional dedicated app host (e.g. https://app.propojo.com). Empty = stay on the current origin. */
export const APP_URL = (process.env.REACT_APP_APP_URL || "").replace(/\/+$/, "");

const rootDomain = APP_URL.replace(/^https?:\/\/[^.]+\./, "");

/** Only hand off between hosts of the same site (propojo.com -> app.propojo.com).
 *  Preview and localhost keep the session on their own origin. */
const onAppHost = () =>
  !APP_URL || window.location.origin === APP_URL || !window.location.hostname.endsWith(rootDomain);

/** The app host is only usable once its DNS *and* SSL certificate are live. Probe it before
 *  sending anyone there, otherwise a half-configured domain locks users out of the product.
 *  The answer is cached for the tab. */
let reachable = null;
const appHostReachable = async () => {
  if (reachable !== null) return reachable;
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 2500);
    await fetch(`${APP_URL}/favicon.ico`, { mode: "no-cors", cache: "no-store", signal: controller.signal });
    clearTimeout(timer);
    reachable = true;
  } catch {
    reachable = false;
  }
  return reachable;
};

/** Hands the freshly issued session to the app host once, then returns true so callers stop routing. */
export const gotoApp = async (token, path = "/dashboard") => {
  if (onAppHost()) return false;
  if (!(await appHostReachable())) return false;
  window.location.replace(`${APP_URL}${path}${token ? `#t=${encodeURIComponent(token)}` : ""}`);
  return true;
};

/** Consumes a `#t=<token>` handoff on load. */
export const consumeTokenHandoff = () => {
  const hash = window.location.hash || "";
  if (!hash.includes("t=")) return false;
  const token = new URLSearchParams(hash.replace(/^#/, "")).get("t");
  if (!token) return false;
  localStorage.setItem("nv_token", token);
  window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
  return true;
};
